export default __webpack_public_path__ + "static/media/hive logo 2.985c5002.svg";